import { Calendar } from "primereact/calendar";
import React, { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import * as Fa from "react-icons/fa";
import { MultiSelect } from "primereact/multiselect";
import { fetchData } from "../../Services/GlobalService";
import { format, subDays } from "date-fns";
import { toast } from "react-toastify";
import { downloadExcelDateFormat } from "../../Services/GlobalFunction/DownLoadExcel";
import { GetDateFormat } from "../../Services/GlobalFunction/GetDateFormat";

const AssortMentReport = () => {
  const sevendate = subDays(new Date(), 7);
  const [typeDwndtype, setTypeDwndtype] = useState("Summary");
  const [reprtinvType, setReprtinvType] = useState<any>({
    name: "Full Invoice",
    code: "FULL",
  });
  const [selectedschm, setSelectedschm] = useState<any>([]);
  const [listschm, setListschm] = useState<any>([]);
  const [loadingExcel, setloadingExcel] = useState<boolean>(false);
  const [toDate, setToDate] = useState<Date>(new Date());
  const [fromdate, setFromdate] = useState<Date>(sevendate);

  const InvTypeLst = [
    { name: "Full Invoice", code: "FULL" },
    { name: "Pending Invoice", code: "PENDING" },
  ];
  const Controller = "AssortmentReport";
  const EndPoint = {
    AllAssortmentScheme: "AllAssortmentScheme",
    AllAssortmentSchemeDetails: "AllAssortmentSchemeDetails",
  };
  //   /api/AssortmentReport/AllAssortmentScheme
  // /api/AssortmentReport/AllAssortmentSchemeDetails

  const getSchemelist = async () => {
    if (fromdate && new Date(fromdate) > new Date()) {
      toast.warn("The 'From Date' cannot be a future date");
      return; // stop execution
    }
    if (fromdate && toDate && new Date(fromdate) > new Date(toDate)) {
      toast.warn("'From Date' cannot be after 'To Date'");
      return;
    }

    try {
      let getschmlst = await fetchData(
        Controller,
        `${EndPoint.AllAssortmentScheme}`,
        `from_date=${format(fromdate ?? "", "dd/MM/yyyy")}&to_date=${format(
          toDate ?? "",
          "dd/MM/yyyy"
        )}`
      );

      if (getschmlst.Data.length == 0) {
        toast.warn("No Scheme found between these days");
      } else {
        toast.info("Scheme populated successfully");
        setListschm(getschmlst.Data);
      }
      setSelectedschm([]);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  let handleDownload = async () => {
    if (selectedschm.length > 10) {
      toast.warn("A maximum of 10 scheme codes can be selected at a time");
      return;
    }
    let lstschm = selectedschm.map((item: any) => item.scheme_code).join(",");
    try {
      setloadingExcel(true);
      let getschmlst = await fetchData(
        Controller,
        `${EndPoint.AllAssortmentSchemeDetails}`,
        `scheme_code=${lstschm}&INV_TYPE=${
          reprtinvType.code
        }&type=${typeDwndtype.toLocaleUpperCase()}`
      );
      if (getschmlst?.Data?.length !== 0) {
        downloadExcelDateFormat(
          getschmlst.Data,
          `FOC_Scheme_Report${GetDateFormat()}.xlsx`
        );
        selectedschm([]);
      } else {
        toast.warn("No data found");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setloadingExcel(false);
    }
  };

  return (
    <>
      <main>
        <div className="col-12 mb-5">
          <div className="row">
            {/* Breadcrumb  */}
            <div className="col-lg-12 col-md-12 col-sm-12">
              <nav aria-label="breadcrumb" className="drop-in">
                <ol className="breadcrumb mx-0">
                  <li className="breadcrumb-item">Reports</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    On Invoice FOC Scheme Report
                  </li>
                </ol>
              </nav>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12">
              <h3 className="py-2">On Invoice FOC Scheme Report</h3>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12"></div>
          </div>

          <section className="sales-box">
              <div className="row d-flex justify-content-center align-items-center">
                <div className="col-lg-5 col-md-12 col-sm-12">
                  <form>
                    <div className="row dashed-brdr-bottom mb-2 pb-2">
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="d-block mb-2">
                          <label className="form-label">From Date</label>
                          <Calendar
                            value={fromdate}
                            onChange={(e) => setFromdate(e.value as Date)}
                            showIcon
                            dateFormat="dd/mm/yy"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="d-block mb-2">
                          <label className="form-label">To Date</label>
                          <Calendar
                            value={toDate}
                            onChange={(e) => setToDate(e.value as Date)}
                            showIcon
                            dateFormat="dd/mm/yy"
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="text-end mt-2">
                          <button
                            type="button"
                            className="btn anime-btn"
                            onClick={getSchemelist}
                          >
                            Get Schemes
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12">
                      <div className="d-block mb-2">
                        <label className="form-label">Schemes</label>
                        <MultiSelect
                          value={selectedschm}
                          onChange={(e) => {
                            setSelectedschm(e.value);
                          }}
                          options={listschm}
                          selectAllLabel="Select All"
                          optionLabel="scheme_code"
                          placeholder="Select Schemes"
                          filter
                        />
                      </div>
                    </div>
                    <div className="row d-flex justify-content-end align-items-end">
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="d-block mb-2">
                          <label className="form-label">Invoice type</label>
                          <Dropdown
                            value={reprtinvType}
                            onChange={(e) => {
                              setReprtinvType(e.value);
                            }}
                            options={InvTypeLst}
                            optionLabel="name"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="d-block mb-2">
                          <RadioButton
                            inputId="invType1"
                            name="Summary"
                            value="Summary"
                            onChange={(e) => setTypeDwndtype(e.value)}
                            checked={typeDwndtype === "Summary"}
                          />
                          <label htmlFor="invType1" className="ms-1">
                            Summary
                          </label>

                          <RadioButton
                            inputId="invType2"
                            name="Detail"
                            value="Detail"
                            className="ms-3"
                            onChange={(e) => setTypeDwndtype(e.value)}
                            checked={typeDwndtype === "Detail"}
                          />
                          <label htmlFor="invType2" className="ms-1">
                            Detail
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                      <div className="text-end mt-2">
                        <button
                          type="button"
                          className="btn anime-btn"
                          onClick={handleDownload}
                          disabled={selectedschm.length == 0 || loadingExcel}
                        >
                          {loadingExcel ? "Loading..." : "Download Report"}{" "}
                          {loadingExcel ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          ) : (
                            <Fa.FaDownload className="ms-2" />
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="col-lg-7 col-md-12 col-sm-12">
                  <div className="text-end">
                    <img
                      src={require("../../Assets/Images/data_report.png")}
                      className="Side_Img drop-right"
                      alt="innorise"
                    />
                  </div>
                </div>
              </div>
          </section>
        </div>
      </main>
    </>
  );
};

export default AssortMentReport;
